import { lazyRouteComponent } from "@tanstack/react-router";
import { BINDER_FAQS } from "@/components/binder-faqs";

export const PAGE_URL = "https://alkoholprovet.se/egenkontrollparm";
export const OG_IMAGE = "https://alkoholprovet.se/og/default.jpg";
export const TITLE = "Egenkontrollpärm för alkoholservering 2026";

export const DESCRIPTION =
  "Färdig egenkontrollpärm med egenkontrollprogram, rutiner, loggar och checklistor för alkoholservering. 790 kr – 395 kr för Premiummedlemmar. PDF + redigerbar Word.";

const BinderPage = lazyRouteComponent(() => import("./egenkontrollparm.view"), "BinderPage");

export const routeOptions = {
  component: BinderPage,
  head: () => ({
    meta: [
      { title: "Egenkontrollpärm alkoholservering 2026 – mallar & rutiner" },
      { name: "description", content: DESCRIPTION },
      { property: "og:type", content: "product" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: PAGE_URL },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: PAGE_URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          name: TITLE,
          description: DESCRIPTION,
          url: PAGE_URL,
          image: [OG_IMAGE],
          category: "Egenkontrollprogram alkoholservering",
          brand: { "@type": "Brand", name: "Alkoholprovet" },
          inLanguage: "sv-SE",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5.0",
            reviewCount: "2",
          },
          review: [
            {
              "@type": "Review",
              author: { "@type": "Person", name: "Verifierad köpare" },
              reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
              reviewBody: "Hade inte klarat det utan eran hjälp",
              datePublished: "2026-08-27",
            },
            {
              "@type": "Review",
              author: { "@type": "Person", name: "Verifierad köpare" },
              reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
              reviewBody: "Så smidigt och bra!",
              datePublished: "2026-05-24",
            },
          ],
          offers: [
            {
              "@type": "Offer",
              name: "Egenkontrollpärm – engångsköp",
              price: "790",
              priceCurrency: "SEK",
              availability: "https://schema.org/InStock",
              url: PAGE_URL,
              hasMerchantReturnPolicy: {
                "@type": "MerchantReturnPolicy",
                applicableCountry: "SE",
                returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted",
              },
              shippingDetails: {
                "@type": "OfferShippingDetails",
                shippingRate: { "@type": "MonetaryAmount", value: "0", currency: "SEK" },
                shippingDestination: { "@type": "DefinedRegion", addressCountry: "SE" },
                doesNotShip: true,
              },
            },
            {
              "@type": "Offer",
              name: "Egenkontrollpärm – Premiumpris",
              price: "395",
              priceCurrency: "SEK",
              availability: "https://schema.org/InStock",
              url: PAGE_URL,
              hasMerchantReturnPolicy: {
                "@type": "MerchantReturnPolicy",
                applicableCountry: "SE",
                returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted",
              },
              shippingDetails: {
                "@type": "OfferShippingDetails",
                shippingRate: { "@type": "MonetaryAmount", value: "0", currency: "SEK" },
                shippingDestination: { "@type": "DefinedRegion", addressCountry: "SE" },
                doesNotShip: true,
              },
            },
          ],

        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "sv-SE",
          mainEntity: BINDER_FAQS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Hem", item: "https://alkoholprovet.se/" },
            { "@type": "ListItem", position: 2, name: "Egenkontrollpärm", item: PAGE_URL },
          ],
        }),
      },
    ],
  }),
};
